import { render, staticRenderFns } from "./PropostaList.vue?vue&type=template&id=e54b9a3e&scoped=true&"
import script from "./PropostaList.vue?vue&type=script&lang=js&"
export * from "./PropostaList.vue?vue&type=script&lang=js&"
import style0 from "./PropostaList.vue?vue&type=style&index=0&id=e54b9a3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54b9a3e",
  null
  
)

export default component.exports